import { PackagingType } from "api/graphql/generated";
import uniq from "lodash/uniq";

const basePackagingTypes = Object.values(PackagingType);

export enum ExtraPalletsType {
  Pallets_48_40 = "PALLETS_48_40",
  Pallets_48_48 = "PALLETS_48_48",
}
const extraPalletsTypeList = Object.values(ExtraPalletsType);

export const packagingTypeList = uniq([
  ...extraPalletsTypeList,
  PackagingType.Pallets,
  PackagingType.Cartons,
  ...basePackagingTypes,
]);

export type PackagingTypeListItem = typeof packagingTypeList[number];

/** The packaging types supported by smc3 dispatching */
export const smc3AutoApiPackagingTypeList = [
  PackagingType.Bags,
  PackagingType.Bales,
  PackagingType.Barrels,
  PackagingType.Bundles,
  PackagingType.Boxes,
  PackagingType.Containers,
  PackagingType.Crates,
  PackagingType.Cartons,
  PackagingType.Pallets,
  PackagingType.Rolls,
  PackagingType.Skids,
  PackagingType.Totes,
];
